module.exports = __webpack_public_path__ + "img/logoInstagram.bc6c0cc0.svg";